import * as React from 'react';

import { SkeletonElement } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const ListsSkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
`;

export const WishlistListsSkeleton = () => {
  return (
    <ListsSkeletonWrapper>
      <SkeletonElement height={2} width="100%" />
      <SkeletonElement height={30} width="100%" />
    </ListsSkeletonWrapper>
  );
};
